module.exports = __webpack_public_path__ + "static/media/trucke.a0935e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trucke.png
// module id = 30
// module chunks = 0